import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/home/services/user.service';

@Component({
  selector: 'app-update-password-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './update-password-modal.component.html',
  styleUrls: ['./update-password-modal.component.scss', '../../../app.component.scss', '../../../shared/base-modal.style.scss']
})
export class UpdatePasswordModalComponent {
  public dialogData: any;
  public formData = {
    password: "",
    confirmPassword: ""
  }

  constructor(
    public dialogRef: MatDialogRef<UpdatePasswordModalComponent>,
    public dialog: MatDialog,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  submit(submittedData){
    if (submittedData.password !== submittedData.confirm_password) {
      return
    }
    
    let bodyContent = {
      password: submittedData.password
    }

    this.userService.updatePassword(this.dialogData.userId, bodyContent).subscribe({
      next: (res) => {
        if (res.data) {
          this.dialogRef.close({ status: true, message: 'Password has been updated successfully'});
        }else{
          this.dialogRef.close({ status: false, message: "Oops something went wrong."});
        }
      },
      error: (error) => {
        if (error) {
          this.dialogRef.close({ status: false, message: "Oops something went wrong."});
        }
      },
      complete: () => {return} 
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
